// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

export function getAktuelleLegislatur() {
	const today = new Date();
	const year = today.getFullYear();
	const month = today.getMonth();
	const day = today.getDate();

	const start_legislatur = new Date(2025, 2, 26).toISOString().split("T")[0];
	const end_legislatur = getYesterday();

	return [start_legislatur, end_legislatur];
}

export function reformatDate(dateString) {
	const dateArr = dateString.split("-");
	return `${dateArr[2]}.${dateArr[1]}.${dateArr[0]}`;
}

export function getDateRangeString(filter) {
	return `(${reformatDate(filter.start_date)}-${reformatDate(filter.end_date)})`;
}

export function formatDate(dateString) {
	const dateArr = dateString.split(".");
	return `${dateArr[2]}-${dateArr[1]}-${dateArr[0]}`;
}

export function getYesterday() {
	const yesterday = () => {
		const d = new Date();
		d.setDate(d.getDate() - 1);
		return d;
	};

	return yesterday().toISOString().split("T")[0];
}
